import { useEffect, useRef, useState } from "react";
export var useCanClearSearch = function (criteria, result, canClearSearch) {
    var canClearRef = useRef(canClearSearch !== null && canClearSearch !== void 0 ? canClearSearch : (function () { return true; }));
    var criteriaRef = useRef(criteria);
    canClearRef.current = canClearSearch !== null && canClearSearch !== void 0 ? canClearSearch : (function () { return true; });
    criteriaRef.current = criteria;
    var _a = useState(function () { return canClearRef.current(criteriaRef.current); }), state = _a[0], setState = _a[1];
    useEffect(function () {
        setState(canClearRef.current(criteriaRef.current));
    }, [result]);
    return state;
};
//# sourceMappingURL=use-can-clear-search.js.map